export default{
  list:[
    {
      id: 0,
      title: 'Okres od września 1939 do 21 czerwca 1941',
      text: 'Po 17. września Wileńszczyzna znalazła się pod okupacją radziecką. Czas tymczasowości tzw. Zachodniej Białorusi okupant wykorzystał na wywożenie wszelkich zasobów magazynowych oraz maszyn i urządzeń',
      url: '/historia/okres_39_41',
      img: '/historia/okres_39_41.jpg'
    },
    {
      id: 1,
      title: 'Okres od czerwca 1941 do lipca 1944',
      text: 'W połowie 1942 r. Komenda Główna przemianowała dotychczasowy Związek Walki Zbrojnej na Armię Krajową odróżniając część sił zbrojnych Polskiego Państwa Podziemnego od sił zbrojnych na zachodzie to jest jednostek walczących pod ogólnym dowództwem aliantów.',
      url: '/historia/okres_41_44',
      img: '/historia/okres_41_44.jpg'
    },
    {
      id: 2,
      title: 'Działalność bojowa Oddziałów i Brygad',
      text: 'Działalność bojowa Oddziałów i Brygad wraz z listą brygad oraz oddziałów Okręgu Wileńskiego Armii Krajowej rozpisaną wedug kolejności rozpoczęcia działań',
      url: '/historia/dzialalnosc_bojowa',
      img: '/historia/dzialalnosc_bojowa.jpg'
    },
    {
      id: 3,
      title: 'Powołanie Zgrupowań – operacja „Ostra Brama”',
      text: 'Lista powoanych zgrupowań z uwzględnieniem uczestników oraz dowódców inspektoratów, plany operacji, urtyfikowania miasta Wilna oraz fragment dokumentu "Droga do „Ostrej Bramy”"',
      url: '/historia/powolanie_zgrupowan',
      img: '/historia/powolanie_zgrupowan.jpg'
    },
    {
      id: 4,
      title: 'Rozbrojenie, aresztowanie, epilog, dokumenty',
      text: 'Dnia 17 lipca 1944 roku wydzielony z szeregów 7. Brygady Oddział po wycofaniu się z Bogusz, forsownym marszem dowodzony przez Komendanta "Wilhelma" przesuwał się w kierunku Puszczy Rudnickiej. Po drodze napotkał pozostałą część Brygady ,czasowo dowodzoną przez kpt. "Czarnego Jana".',
      url: '/historia/rozbrojenie_aresztowanie_epilog_dokumenty',
      img: '/historia/rozbrojenie_aresztowanie_epilog_dokumenty.jpg'
    },
    {
      id: 5,
      title: 'Tablice Epitafijne Okręgu Wileńskiego',
      text: 'Zdjęcia tablic epitafijnych Okręgu Wileńskiego z podziałem na miasta, w których się znajdują oraz z opisem dokładnej lokalizacji poszczególnych tablic',
      url: '/historia/tablice_epitafijne',
      img: '/historia/tablice_epitafijne.jpg'
    },
    {
      id: 6,
      title: 'Bibliografia',
      text: '',
      url: '/historia/bibliografia',
      img: '/historia/bibliografia.jpg'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/models/historia.js